<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    form: Snippet;
  }

  let { form }: Props = $props();
</script>

<main
  class="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 flex items-center justify-center p-6 relative overflow-hidden"
>
  <div
    class="absolute top-1/4 -left-20 w-72 h-72 bg-indigo-500/20 rounded-full blur-3xl pointer-events-none"
  ></div>
  <div
    class="absolute bottom-1/4 -right-20 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl pointer-events-none"
  ></div>

  {@render form()}
</main>
